<form [formGroup]="firebaseSettingsForm" id="firebaseSettingsWrapper" class="genieSettingsWrapper" (ngSubmit)="onSubmit()">
  <button *ngIf="this.builderService.getTour()" class="tourNextActionUpper stacksBtn green" type="button" (click)="generalSettingsNext()">
    {{ 'Next' | translate }}
  </button>
  <div *ngIf="this.builderService.getTour()" class="generalSettingsTourHeader">
    <h1>{{ 'Initial Setup' | translate }}</h1>
    <p>{{ 'You can leave the below settings as they are and edit them later. ' | translate }}</p>
  </div>

  <div class="adv_setting_group">
    <div class="backButton" (click)="builderService.navigateBack()">
      <img src="/assets/icons/arrow-left.svg" [alt]="'Go back' | translate" />
    </div>
    <div class="firstCont">
      <div>
        <p class="adv_setting">{{ 'Advanced Settings' | translate }}</p>
        <p class="dev_level">{{ 'Developer-level configurations for cloud infrastructure and tracking.' | translate }}</p>
      </div>
      <button type="submit" class="saveButton" [disabled]="saving">
        {{ 'Save Changes' | translate }}
      </button>
    </div>
  </div>

  <div class="section-card">
    <div class="card-header">
      <p class="fire_config">{{ 'Firebase Configuration' | translate }}</p>
      <p class="auth_data">{{ 'Authentication, Database, and Cloud Storage' | translate }}</p>
    </div>
    <div class="card-body">
      <div class="fields-grid">
        <!--this is the firebase Api key-->
        <div class="field-wrapper">
          <div class="field-wrapper">
            <div class="field-label-row">
              <label>{{ 'Api Key' | translate }}</label>
            </div>
            <div class="genie-input">
              <input [placeholder]="'AIzWatzv_pNQq9YAHqjfJw8wVtmsdNfrsD8zc00' | translate" formControlName="stacks_user_apiKey" value="{{ this.firebaseSettingsData?.stacks_user_apiKey }}" />
            </div>
          </div>
        </div>
        <!--this is the firebase Auth Domain-->
        <div class="field-wrapper">
          <div class="field-wrapper">
            <div class="field-label-row">
              <label>{{ 'Auth Domain' | translate }}</label>
            </div>
            <div class="genie-input">
              <input placeholder="stacks-887ad.firebaseapp.com" formControlName="stacks_user_authDomain" value="{{ this.firebaseSettingsData?.stacks_user_authDomain }}" />
            </div>
          </div>
        </div>
        <!--this is the firebase database URL-->
        <div class="field-wrapper">
          <div class="field-wrapper">
            <div class="field-label-row">
              <label>{{ 'Database URL' | translate }}</label>
            </div>
            <div class="genie-input">
              <input placeholder="https://stacks-d88fd-default-rsbc.firebaseio.com" formControlName="stacks_user_databaseURL" value="{{ this.firebaseSettingsData?.stacks_user_databaseURL }}" />
            </div>
          </div>
        </div>
        <!--this is the firebase project Id-->
        <div class="field-wrapper">
          <div class="field-wrapper">
            <div class="field-label-row">
              <label>{{ 'Project Id' | translate }}</label>
            </div>
            <div class="genie-input">
              <input [placeholder]="'stacks-d88fd' | translate" formControlName="stacks_user_projectId" value="{{ this.firebaseSettingsData?.stacks_user_projectId }}" />
            </div>
          </div>
        </div>
        <!--this is the firebase storage Bucket-->
        <div class="field-wrapper">
          <div class="field-wrapper">
            <div class="field-label-row">
              <label>{{ 'Storage Bucket' | translate }}</label>
            </div>
            <div class="genie-input">
              <input placeholder="stacks-d88fd.firebasestorage.app" formControlName="stacks_user_storageBucket" value="{{ this.firebaseSettingsData?.stacks_user_storageBucket }}" />
            </div>
          </div>
        </div>
        <!--this is the firebase messaging Sender Id-->
        <div class="field-wrapper">
          <div class="field-wrapper">
            <div class="field-label-row">
              <label>{{ 'Messaging Sender Id' | translate }}</label>
            </div>
            <div class="genie-input">
              <input placeholder="stacksSenderId" formControlName="stacks_user_messagingSenderId" value="{{ this.firebaseSettingsData?.stacks_user_messagingSenderId }}" />
            </div>
          </div>
        </div>
        <!--this is the firebase app Id-->
        <div class="field-wrapper">
          <div class="field-wrapper">
            <div class="field-label-row">
              <label>{{ 'App Id' | translate }}</label>
            </div>
            <div class="genie-input">
              <input placeholder="3:329767666114:web:75fb111256742034141x43" formControlName="stacks_user_appId" value="{{ this.firebaseSettingsData?.stacks_user_appId }}" />
            </div>
          </div>
        </div>
        <!--this is the firebase measurement Id-->
        <div class="field-wrapper">
          <div class="field-wrapper">
            <div class="field-label-row">
              <label>{{ 'Measurement Id' | translate }}</label>
            </div>
            <div class="genie-input">
              <input [placeholder]="'Q-QM7GAFGNP5' | translate" formControlName="stacks_user_measurementId" value="{{ this.firebaseSettingsData?.stacks_user_measurementId }}" />
            </div>
          </div>
        </div>
        <!-- Google Service File Upload -->
        <div class="field-wrapper upload-section">
          <div class="field-label-row">
            <label>{{ 'Google service file' | translate }}</label>
          </div>

          <div class="upload-area" [class.has-file]="googleServiceJsonFile">
            <input type="file" formControlName="google_filepath" id="google_filepath" (change)="processFile($event, 'application/octet-stream', 'google_filepath')" accept="application/octet-stream" />

            <div *ngIf="!googleServiceJsonFile && !isGoogleServiceJsonUploading" class="upload-content">
              <div class="upload-icon-circle">
                <svg width="47" height="47" viewBox="0 0 47 47" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="3.33301" y="3.33398" width="40" height="40" rx="20" fill="#ECF5F8" />
                  <rect x="3.33301" y="3.33398" width="40" height="40" rx="20" stroke="#F9FAFB" stroke-width="6.66667" />
                  <path
                    d="M20 26.6673L23.3333 23.334M23.3333 23.334L26.6667 26.6673M23.3333 23.334V30.834M30 27.2863C31.0179 26.4457 31.6667 25.1739 31.6667 23.7507C31.6667 21.2193 29.6146 19.1673 27.0833 19.1673C26.9012 19.1673 26.7309 19.0723 26.6384 18.9154C25.5517 17.0713 23.5454 15.834 21.25 15.834C17.7982 15.834 15 18.6322 15 22.084C15 23.8057 15.6962 25.3649 16.8225 26.4953"
                    stroke="url(#paint0_linear_google)"
                    stroke-width="1.66667"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <defs>
                    <linearGradient id="paint0_linear_google" x1="23.8178" y1="41.8996" x2="20.7349" y2="16.145" gradientUnits="userSpaceOnUse">
                      <stop stop-color="#7CEEE6" />
                      <stop offset="0.495192" stop-color="#3A95B9" />
                      <stop offset="0.990385" stop-color="#004691" />
                    </linearGradient>
                  </defs>
                </svg>
              </div>
              <div class="upload-text">{{ 'click to Upload' | translate }}</div>
              <div class="upload-hint">{{ 'Upload google-services.json or GoogleService-Info.plist ( Max 5 mb )' | translate }}</div>
            </div>

            <div *ngIf="googleServiceJsonFile && !isGoogleServiceJsonUploading" class="file-uploaded">
              <div class="file-info">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9 12L11 14L15 10M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="#10B981" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                <span class="file-name">{{ googleServiceJsonFile }}</span>
              </div>
              <button type="button" class="remove-file-btn" (click)="clearFileName('google_filepath')" mat-icon-button>
                <mat-icon>close</mat-icon>
              </button>
            </div>

            <div *ngIf="isGoogleServiceJsonUploading" class="uploading-state">
              <mat-spinner diameter="24"></mat-spinner>
              <span>{{ 'Uploading...' | translate }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="section-card">
    <div class="card-header">
      <p class="fire_config">{{ 'Meta Pixel' | translate }}</p>
      <p class="auth_data">{{ 'Analytics and advertising conversion tracking' | translate }}</p>
    </div>

    <div class="card-body">
      <div class="fields-grid">
        <div class="field-wrapper">
          <div class="field-label-row">
            <label>{{ 'Pixel ID' | translate }}</label>
          </div>
          <div class="genie-input">
            <input [placeholder]="'Pixel ID' | translate" formControlName="meta_pixel_id" />
          </div>
        </div>

        <div class="field-wrapper">
          <div class="field-label-row">
            <label>{{ 'Client Token' | translate }}</label>
          </div>
          <div class="genie-input">
            <input [placeholder]="'Client Token' | translate" formControlName="meta_client_token" />
          </div>
        </div>

        <div class="field-wrapper">
          <div class="field-label-row">
            <label>{{ 'Display Name' | translate }}</label>
          </div>
          <div class="genie-input">
            <input [placeholder]="'Display Name' | translate" formControlName="facebook_displayName" />
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="section-card">
    <div class="card-header">
      <p class="fire_config">{{ 'Hotjar' | translate }}</p>
      <p class="auth_data">{{ 'Session recording and heatmap analytics' | translate }}</p>
    </div>

    <div class="card-body">
      <div class="fields-grid">
        <div class="field-wrapper">
          <div class="field-label-row">
            <label>{{ 'Site ID' | translate }}</label>
          </div>
          <div class="genie-input">
            <input [placeholder]="'Site ID' | translate" formControlName="hotjar_id" />
          </div>
          <p class="field-error" *ngIf="firebaseSettingsForm.get('hotjar_id')?.invalid && firebaseSettingsForm.get('hotjar_id')?.dirty">
            {{ 'Hotjar Site ID must contain digits only' | translate }}
          </p>
        </div>
      </div>
    </div>
  </div>

  <div class="section-card">
    <div class="card-header">
      <p class="fire_config">{{ 'Google Analytics' | translate }}</p>
      <p class="auth_data">{{ 'Website traffic and sales tracking' | translate }}</p>
    </div>

    <div class="card-body">
      <div class="fields-grid">
        <div class="field-wrapper">
          <div class="field-label-row">
            <label>{{ 'Measurement Id' | translate }}</label>
          </div>
          <div class="genie-input">
            <input placeholder="G-XXXXXXXXXX" formControlName="measurement_id" />
          </div>
          <p class="field-error" *ngIf="firebaseSettingsForm.get('measurement_id')?.invalid && firebaseSettingsForm.get('measurement_id')?.dirty">
            {{ 'Measurement ID must start with G-' | translate }}
          </p>
        </div>
      </div>
    </div>
  </div>

  <button *ngIf="this.builderService.getTour()" id="tourNextAction" type="button" (click)="generalSettingsNext()">
    {{ 'Next' | translate }}
  </button>
</form>
